/******** Swiper inicialization ********/
class CodiSwiper {
    constructor(element, additionalSwiper) {
      var options =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.element = element;
      this.thumb = additionalSwiper;
      this.initialConfig = JSON.parse(
        element.getAttribute("data-swiper-settings")
      );
  
      if (additionalSwiper) {
        this.initialConfigThumbs = JSON.parse(
          additionalSwiper.getAttribute("data-swiper-thumb-settings")
        );
      }
      this.options = options;
      this.build();
    }
  
    selectCell(index) {
      this.swiperElement.slideTo(index);
    }
  
    resize() {
      this.swiperElement.resize();
    }
  
    build() {
      var _this = this,
        configThumb = this.initialConfigThumbs;
        
      if (configThumb != null) {
        this.thumbSwiper = new Swiper(this.thumb, configThumb);
        this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
      }
  
      this.swiperElement = new Swiper(this.element, this.initialConfig);
      this.selectedIndex = this.swiperElement.activeIndex;
  
      this.swiperElement.on("slideChange", function () {
  
        _this.element.dispatchEvent(
          new CustomEvent("swiper:slide-changed", {
            bubbles: true,
            detail: {
              currentIndex: _this.swiperElement.activeIndex,
              element: _this.swiperElement.el[0],
            },
          })
        );
      });
  
  
    }
}
/******** Swiper inicialization ********/
  
/****** Swiper section ******/
class NewSwiper extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.carouselElement = this.element.querySelector(".swiper");
        this.carousel = new CodiSwiper(this.carouselElement);
    }
}
customElements.define("swiper-component", NewSwiper);
/****** Swiper section ******/

/******** Banner ********/
class mainBanner extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new CodiSwiper(this.carouselElement);
      this.createObserver();
  }

  createObserver() {
    this.observer = new IntersectionObserver(this.changeImageQuality.bind(this), {
      threshold: 0.5,
    });

    const target = this.element;
    this.observer.observe(target);
  }

  changeImageQuality(singleItem) {
    let imageContainers;
    // Determine which element(s) to search for based on the singleItem parameter.
    if (singleItem) {
      imageContainers = Array.from(
        this.element.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    } else {
      const currentIndex = this.carousel.swiperElement.activeIndex;
      const cellElement = this.carousel.swiperElement.slides[currentIndex];
      imageContainers = Array.from(
        cellElement.querySelectorAll(".Banner__ImageContainer--Swap")
      );
    }

    // If no image containers are found, return.
    if (imageContainers.length === 0) {
      return;
    }

    imageContainers.forEach(container => {
      const images = container.querySelectorAll(".Banner__Image");
  
      images.forEach(image => {
        // Skip the image if it has already been loaded.
        if (image.dataset.loadedImage === "true") {
          return;
        }
  
        // Determine the quality based on the current breakpoint and update URL.
        const replaceUrl = image.dataset.src.replace("{width}x", "width=2600");
        image.src = replaceUrl;
        image.dataset.loadedImage = "true";
      });
    });
  }
}
customElements.define("main-banner", mainBanner);
/******** Banner ********/

document.querySelectorAll('.category-filter button').forEach(button => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    const filter = button.dataset.filter;

    document.querySelectorAll('.category-filter button').forEach(btn =>
      btn.classList.remove('active')
    );
    button.classList.add('active');

    document.querySelectorAll('.card').forEach(card => {
      const category = card.dataset.category;

      if (filter === 'All' || category === filter) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  });
});


class customFilter extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.customFilterButtons = document.querySelectorAll('.custom-filter');
        this.desktopSortBy = document.querySelector('#desktop-SortBy');
        this.mobileSortBy = document.querySelector('#mobile-SortBy');

        this.handleFilterClicks();
        this.activateFilterFromURL();
    }

    handleFilterClicks() {
        this.customFilterButtons.forEach((filterButton) => {
            filterButton.addEventListener('click', (e) => {
                e.preventDefault();
                const filter = filterButton.dataset.filter;

                //this.updateActiveState(filterButton);
                this.syncActiveFilterButtons(filter);
                this.updateURL(filter);
                this.filterProducts(filter);
                this.handlePagination();
            });
        });

        this.desktopSortBy.addEventListener('change', () => {
          setTimeout(() => {
            this.resetFilterUIIfShowingAll();
          }, 500)
            
        });
        this.mobileSortBy.addEventListener('change', () => {
          setTimeout(() => {
            this.resetFilterUIIfShowingAll();
          }, 500)
            
        });

    }

    resetFilterUIIfShowingAll() {
      console.log('reset')
      this.customFilterButtons.forEach(btn => btn.classList.remove('active'));
    }

    syncActiveFilterButtons(filter) {
      this.customFilterButtons.forEach(btn => {
        if (btn.dataset.filter === filter) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    }

    updateActiveState(activeButton) {
        this.customFilterButtons.forEach(btn => btn.classList.remove('active'));
        activeButton.classList.add('active');
    }

    updateURL(filter) {
      const url = new URL(window.location.href);
      url.searchParams.set('filter', filter); // zadrži ostale parametre
      window.history.replaceState({}, '', url.toString());
    }


    activateFilterFromURL() {
        const url = new URL(window.location);
        const filter = url.searchParams.get('filter');

        let defaultBtn = this.customFilterButtons[0]; // fallback if no match

        if (filter) {
            const matchingBtn = [...this.customFilterButtons].find(btn => btn.dataset.filter === filter);
            if (matchingBtn) defaultBtn = matchingBtn;
        }

        defaultBtn?.click(); // triggers all logic
    }

    filterProducts(filter) {
        document.querySelectorAll('.product-item').forEach(card => {
            const categories = card.dataset.category;
            const categoryArray = categories
                ? categories.split(',').map(cat => cat.trim())
                : [];

            card.style.display = (filter === 'All' || categoryArray.includes(filter)) ? '' : 'none';
        });
    }

    handlePagination() {
        const visibleCards = document.querySelectorAll('.product-item:not([style*="display: none"])');
        const pagination = document.querySelector('.pagination');
        const productNum = document.querySelector('#CollectionProductCount');

        const visibleCount = visibleCards.length;

        if (productNum) {
            productNum.textContent = `Showing ${visibleCount} product${visibleCount !== 1 ? 's' : ''}`;
        }

        if (pagination) {
            pagination.style.display = visibleCount === 0 ? 'none' : '';
        }
    }
}

customElements.define('custom-filters', customFilter);

const widgetObserver = new MutationObserver(() => {
  const hostElement = document.querySelector('recharge-subscription-widget');
  if (hostElement && hostElement.shadowRoot) {
    const target = hostElement.shadowRoot.querySelector('.rc-selection__root');
    if (target) {
      target.style.display = 'flex';
      target.style.flexDirection = 'column-reverse';
      target.style.gap = '1rem';

      // Gotovo – ne moramo više da osluškujemo
      widgetObserver.disconnect();
    }
  }
});

widgetObserver.observe(document.body, { childList: true, subtree: true });